import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { getAuthToken } from '../utils/auth'

const token = getAuthToken()
const BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'https://pro.vibelinksapp.com/api'

// Async thunk for fetching posts
export const fetchPosts = createAsyncThunk(
  'posts/fetchPosts',
  async ({ pageUrl, queryParams } = {}, { rejectWithValue }) => {
    try {
      // Build query string if queryParams exist
      const queryString = queryParams
        ? '?' +
          Object.entries(queryParams)
            .map(
              ([key, value]) =>
                `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
            )
            .join('&')
        : ''

      const url = (pageUrl || `${BASE_URL}/get-post`) + queryString

      const response = await axios.post(url, null, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })

      return response.data
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message)
    }
  }
)

// Initial state
const initialState = {
  posts: [],
  loading: false,
  error: null,
  nextPage: null,
  totalPage: 1
}

const postsSlice = createSlice({
  name: 'posts',
  initialState,
  reducers: {
    clearPosts (state) {
      state.posts = []
      state.nextPage = null
      state.totalPage = 1
      state.error = null
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchPosts.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchPosts.fulfilled, (state, action) => {
        state.loading = false
        state.error = null
        const data = action.payload
        if (data && data.data && Array.isArray(data.data.posts)) {
          state.posts = [...state.posts, ...data.data.posts]
          state.nextPage = data.next_page || null
          state.totalPage = data.total_page || 1
        }
      })
      .addCase(fetchPosts.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  }
})

export const { clearPosts } = postsSlice.actions
export default postsSlice.reducer
